import { render, staticRenderFns } from "./AppAlarmClass.vue?vue&type=template&id=66fbe9c4&scoped=true&"
import script from "./AppAlarmClass.vue?vue&type=script&lang=js&"
export * from "./AppAlarmClass.vue?vue&type=script&lang=js&"
import style0 from "./AppAlarmClass.vue?vue&type=style&index=0&id=66fbe9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fbe9c4",
  null
  
)

export default component.exports